
export class GuidedTourStopModel {
  numberOfSteps: number;
  lastStep: number;
}
